import { EventEmitter, forwardRef } from '@angular/core'
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl, UntypedFormGroup } from '@angular/forms'

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR = component => ({
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => component),
  multi: true,
})

export class FormRowBase implements ControlValueAccessor {
  model: any
  modelChange: EventEmitter<any> = new EventEmitter()
  formControlName: string // @Input() optional for valueAccessor to work, but required for validations
  formGroup: UntypedFormGroup // @Input() optional for valueAccessor to work, may come handy for grouped forms
  control: UntypedFormControl = new UntypedFormControl()
  errors: Array<string> = ['required']

  initFormControl() {
    if (this.formGroup && this.formControlName) {
      this.control = <UntypedFormControl>this.formGroup.get(this.formControlName)
    }
    if (!this.control) {
      return
    }
    this.control.valueChanges.subscribe(() => {
      // check condition if the form control is RESET
      if (this.control.value === '' || this.control.value === null || this.control.value === undefined) {
        this.value = ''
      }
    })
  }

  // call on keyup/change
  onChange(event, numberMax?) {
    if (numberMax !== null && Number(event.target.value) > Number(numberMax)) event.target.value = String(numberMax)
    this.propagateChange(event.target.value)
    this.errors = []
    if (this.control && this.control.errors) {
      this.errors = Object.keys(this.control.errors)
    }
  }

  get value(): any {
    return this.model
  }

  set value(val: any) {
    if (this.model !== val) {
      this.model = val
    }
  }

  propagateChange = (e: any) => {
    return e
  }

  writeValue(value: any) {
    this.model = value
  }

  registerOnChange(fn: any) {
    this.propagateChange = fn
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  registerOnTouched(fn: any) {}

  onNgModelChange(value: string | boolean | unknown, numberMax?): void {
    if (numberMax !== null && Number(value) > Number(numberMax)) value = numberMax
    this.onChange({ target: { value } }, numberMax)
    this.modelChange.emit(value)
  }
}
